import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { CONFERENCE_JOINED, CONFERENCE_LEFT, ENDPOINT_MESSAGE_RECEIVED } from '../base/conference/actionTypes';
import { idImageReceived, joinRoom, leftRoom, removeImage, shareBlobImage } from './actions';
import { SHARE_IMAGE_UPLOAD_FAILURE, SHARE_IMAGE_BLOCKED, SHARE_IMAGE_UPLOAD_SUCCESS, JOIN_ROOM_FAILURE } from './actionTypes';
import { showErrorNotification, showSuccessNotification, showWarningNotification } from '../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { ENDPOINT_MESSAGE_RECEIVED_CAPTURE_RESULT, ENDPOINT_MESSAGE_RECEIVED_COLLAB_IMAGES_IMAGE_ID, ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT, ENDPOINT_MESSAGE_REMOVE_IMAGE } from './constants';
import { getLocalParticipant, getMutedStateByParticipantAndMediaType } from '../base/participants/functions';
import { getCameraParticipant } from '../camera-participant/funcions';
import { getCollabImagesState } from './funtions';
import { getCurrentConference } from '../base/conference/functions';
import { blobFromCamera } from '../toolbox/image-video-capture/functions-2';
import Toastify from 'toastify-js';
MiddlewareRegistry.register(store => next => async (action) => {
    const result = next(action);
    if (action.type === ENDPOINT_MESSAGE_RECEIVED) {
        const { data } = action;
        const { type } = data;
        switch (type) {
            case ENDPOINT_MESSAGE_RECEIVED_COLLAB_IMAGES_IMAGE_ID: {
                const payload = data.payload;
                store.dispatch(idImageReceived(payload.id));
                break;
            }
            case ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT: {
                const { participantId, fromParticipantId } = data.payload;
                const localParticipant = getLocalParticipant(store);
                const conference = getCurrentConference(store);
                if (!localParticipant || !conference)
                    return;
                const sendResult = (success, text) => {
                    conference.sendMessage({
                        type: ENDPOINT_MESSAGE_RECEIVED_CAPTURE_RESULT,
                        payload: {
                            success,
                            text
                        },
                    }, fromParticipantId);
                };
                let targetParticipant = null;
                if (localParticipant.id === participantId) {
                    const isVideoHidden = getMutedStateByParticipantAndMediaType(store, localParticipant, 'video');
                    if (isVideoHidden) {
                        sendResult(false, 'El video del usuario esta oculto.');
                        return;
                    }
                    // El mensaje pide capturar mi propia cámara
                    if (localParticipant.cameraDeviceId) {
                        targetParticipant = { deviceId: localParticipant.cameraDeviceId };
                    }
                }
                else {
                    // El mensaje pide capturar la cámara de otro participante
                    const cameraParticipant = getCameraParticipant(store, participantId);
                    // Es mi camara
                    if (cameraParticipant) {
                        targetParticipant = { deviceId: cameraParticipant.deviceId };
                    }
                }
                if (!targetParticipant)
                    return;
                const { excalidrawApi } = getCollabImagesState(store.getState());
                if (!excalidrawApi) {
                    sendResult(false, "El participante no tiene la pizarra activa.");
                    return;
                }
                if (excalidrawApi.getSceneElements().filter(e => e.type === 'image').length >= 6) {
                    sendResult(false, "6 de 6 imagenes en la pizarra.");
                    return;
                }
                if (document.hidden) {
                    sendResult(false, "El participante no tiene la pagina en primer plano, pruebe con una captura local.");
                    return;
                }
                try {
                    const isFlipped = store.getState()['features/flip'].participantIds.includes(participantId);
                    const blob = await blobFromCamera(targetParticipant.deviceId, isFlipped);
                    store.dispatch(shareBlobImage(blob, excalidrawApi, (success) => {
                        if (success) {
                            const { excalidrawApi } = getCollabImagesState(store.getState());
                            if (excalidrawApi) {
                                sendResult(true, `${excalidrawApi.getSceneElements().filter(e => e.type === 'image').length} de 6 imagenes en la pizarra`);
                            }
                            else {
                                sendResult(true);
                            }
                        }
                        else {
                            sendResult(false);
                        }
                    }));
                }
                catch (error) {
                    sendResult(false, 'Error desconocido.');
                }
                break;
            }
            case ENDPOINT_MESSAGE_RECEIVED_CAPTURE_RESULT: {
                const { success, text } = data.payload;
                if (success) {
                    Toastify({
                        text: '¡Peticion de captura realizada con éxito!',
                        duration: 3000,
                        close: false,
                        gravity: 'top',
                        position: 'right',
                        backgroundColor: '#4CAF50',
                        stopOnFocus: true
                    }).showToast();
                    if (text) {
                        store.dispatch(showSuccessNotification({
                            title: 'Peticion de captura',
                            description: text,
                        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                    }
                }
                else {
                    store.dispatch(showErrorNotification({
                        title: 'Peticion de captura',
                        description: text ? text : 'Error desconocido.',
                        hideErrorSupportLink: true,
                    }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                }
            }
            case ENDPOINT_MESSAGE_REMOVE_IMAGE: {
                const { id } = data.payload;
                store.dispatch(removeImage(id));
            }
        }
    }
    if (action.type === CONFERENCE_JOINED) {
        const conference = action.conference;
        const roomName = conference.getName();
        store.dispatch(joinRoom(roomName));
    }
    if (action.type === CONFERENCE_LEFT) {
        store.dispatch(leftRoom());
    }
    if (action.type === JOIN_ROOM_FAILURE) {
        const { error } = action;
        store.dispatch(showErrorNotification({
            title: 'Error al unirse a la sala de imágenes compartidas',
            description: error,
            hideErrorSupportLink: true
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    }
    if (action.type === SHARE_IMAGE_UPLOAD_SUCCESS) {
        const excalidrawApi = store['getState']()['features/collab-images'].excalidrawApi;
        if (excalidrawApi) {
            const images = excalidrawApi.getSceneElements().filter(e => e.type === 'image');
            store.dispatch(showSuccessNotification({
                title: 'Imagen añadida',
                description: `${images.length} de 6 disponibles.`,
            }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        }
        else {
            store.dispatch(showSuccessNotification({
                title: 'Imagen añadida',
                description: 'Haz añadido una imagen correctamente.',
            }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        }
    }
    if (action.type === SHARE_IMAGE_BLOCKED) {
        const { payload } = action;
        store.dispatch(showWarningNotification({
            title: 'Accion bloqueada.',
            description: payload.cause,
            hideErrorSupportLink: true
        }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
    }
    if (action.type === SHARE_IMAGE_UPLOAD_FAILURE) {
        const { payload } = action;
        store.dispatch(showErrorNotification({
            title: 'Error al añadir',
            description: payload.cause,
            hideErrorSupportLink: true
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    }
    return result;
});
